import React from 'react';
import { useContextSelector } from 'use-context-selector';
import { CatalogContext } from '@context/catalog.context';
import clsx from 'clsx';
import { useTranslation } from 'next-i18next';
import Pagination from '@components/catalog/pagination/pagination';
import MobilePagination from '@components/catalog/pagination/mobile-pagination/mobile-pagination';
import styles from './product-search/product-search.module.scss';

const BottomPaginationSection: React.FC = (): React.JSX.Element => {
  const { t } = useTranslation();
  const pageCount = useContextSelector(CatalogContext, (v) => v.pageCount);
  const currentPage = useContextSelector(CatalogContext, (v) => v.currentPage);
  const queryResult = useContextSelector(CatalogContext, (v) => v.queryResult);
  const resultsPerPage = useContextSelector(CatalogContext, (v) => v.resultsPerPage);
  const setResultsPerPage = useContextSelector(CatalogContext, (v) => v.setResultsPerPage);
  const updateCurrentPage = useContextSelector(CatalogContext, (v) => v.updateCurrentPage);
  const products = useContextSelector(CatalogContext, (v) => v.products);

  const DEFAULT_LIMIT = 48;

  return (
    <>
      <div className={styles.catalog__pagination__mobileContainer}>
        <MobilePagination
          handleNext={() => updateCurrentPage(currentPage + 1, true)}
          handlePrevious={() => updateCurrentPage(currentPage - 1, true)}
          currentPage={currentPage}
          pageCount={queryResult?.paginationStats?.totalPages || currentPage}
          showScrollTop={products.length > 4}
        />
      </div>
      <div className={clsx(styles.catalog__pagination, styles['catalog__pagination--lower'])}>
        <div className={styles.catalog__resultsPerPageContainer}>
          {t('CATALOG.FILTERS.HITS_PER_PAGE_LABEL')}
          <button
            data-cy="catalog-set-results-per-page-to-1x-limit-button"
            className={clsx(
              styles.catalog__resultsPerPageButton,
              resultsPerPage === DEFAULT_LIMIT && styles['catalog__resultsPerPageButton--active'],
            )}
            onClick={() => setResultsPerPage(DEFAULT_LIMIT)}
          >
            {DEFAULT_LIMIT}
          </button>
          <button
            data-cy="catalog-set-results-per-page-to-2x-limit-button"
            className={clsx(
              styles.catalog__resultsPerPageButton,
              resultsPerPage === DEFAULT_LIMIT * 2 && styles['catalog__resultsPerPageButton--active'],
            )}
            onClick={() => setResultsPerPage(DEFAULT_LIMIT * 2)}
          >
            {DEFAULT_LIMIT * 2}
          </button>
        </div>
        <Pagination
          behaviour="catalog"
          currentPage={currentPage}
          pageCount={pageCount}
          showText={true}
          hasArrows={true}
          onChange={(page) => updateCurrentPage(page)}
        />
      </div>
    </>
  );
};

export default BottomPaginationSection;
